import React, { useEffect, useState, useRef, useMemo } from 'react'
import { Table, Spin, Avatar, Button, Tag, Radio, Space, DatePicker } from 'antd'
import { useNavigate } from 'react-router-dom'
import moment from 'moment'

import Layout from '../../components/layout/Layout'
import axiosInstance from '../../utils/axiosInstance'

const { RangePicker } = DatePicker

function GlobalSearchLogs() {
  const navigate = useNavigate()

  const [logs, setLogs] = useState([])
  const [loading, setLoading] = useState(false)
  const [page, setPage] = useState(1)
  const isFetchingRef = useRef(false)
  const [filter, setFilter] = useState('all')
  const [dateRange, setDateRange] = useState(null)
  const [hideLUsers, setHideLUsers] = useState(true)

  const fetchLogs = async (pageNumber = 1) => {
    if (isFetchingRef.current) return

    setLoading(true)
    isFetchingRef.current = true

    try {
      const response = await axiosInstance.get(`/api/v1/logs/getScreenVisits?screenName=globalSearch&page=${pageNumber}`)
      let newLogs = response.data.logs || []
      // newLogs = newLogs.filter((elem) => elem.userDetails.email != 'L') // Filtering "Kamal2 Hossain" account // ? This is implemented at "filteredLogs()" function

      setLogs((prev) => [...prev, ...newLogs])
    } catch (e) {
      console.error(e)
    } finally {
      setLoading(false)
      isFetchingRef.current = false
    }
  }

  const columns = [
    {
      title: 'User',
      key: 'user',
      render: (_, record) => (
        <div style={{ display: 'flex', alignItems: 'center' }}>
          {/* {record.userDetails?.profilePicture && <Avatar src={record.userDetails.profilePicture} style={{ marginRight: 12 }} />} */}
          <div>
            <div>
              {record.userDetails?.firstName} {record.userDetails?.lastName}
            </div>
            <small>{record.userDetails?.email}</small>
          </div>
        </div>
      ),
    },
    // {
    //   title: 'Cache Used',
    //   dataIndex: 'cacheUsed',
    //   key: 'cacheUsed',
    //   render: (v) => (v ? <Tag color="green">Yes</Tag> : <Tag color="red">No</Tag>),
    // },
    {
      title: 'Query',
      dataIndex: 'query',
      key: 'query',
      render: (v) => {
        return v ? <p>{v.charAt(0).toUpperCase() + v.slice(1)}</p> : <p>-</p>
      },
    },
    {
      title: 'Type',
      dataIndex: 'type',
      key: 'type',
      render: (v) => {
        return v ? <p>{v.charAt(0).toUpperCase() + v.slice(1)}</p> : <p>-</p>
      },
    },

    {
      title: 'Execution time',
      key: 'approximateExecutionTime',
      render: (record) => {
        if (record.approximateExecutionTime) {
          const endOne = record.approximateExecutionTime[0]
          const endTwo = record.approximateExecutionTime[1] / 1e6 // convert nanoseconds to milliseconds
          return (
            <small>
              <span style={{ color: 'red' }}>{endOne > 0 ? `${endOne}s, ` : ``}</span>
              {endTwo.toFixed(2)}ms ({record.currentOnline})
            </small>
          )
        } else {
          return <p>-</p>
        }
      },
    },
    {
      title: 'Visited At',
      dataIndex: 'createdAt',
      key: 'createdAt',
      render: (v) => <small>{moment(v).format('h:mm:ss A, DD MMM YYYY')}</small>,
    },
  ]

  const filteredLogs = useMemo(() => {
    let result = [...logs]

    // Date range filter
    if (dateRange && dateRange.length === 2) {
      const [start, end] = dateRange
      result = result.filter((log) => log.createdAt >= start && log.createdAt <= end)
    }

    return result
  }, [logs, filter, dateRange, hideLUsers])

  useEffect(() => {
    fetchLogs(page)
  }, [page])

  return (
    <Layout>
      <div style={{ padding: 20 }}>
        <h2>Global search queries</h2>

        <Space>
          <Button type="primary" onClick={() => navigate(-1)} style={{ marginBottom: 0 }}>
            Back
          </Button>

          <RangePicker
            showTime
            onChange={(dates) => {
              if (!dates) {
                setDateRange(null)
              } else {
                setDateRange([dates[0].valueOf(), dates[1].valueOf()])
              }
            }}
          />

          {dateRange && <Button onClick={() => setDateRange(null)}>Clear Date</Button>}
        </Space>

        <p>Total items at table: {filteredLogs.length}</p>

        <Table rowKey="_id" columns={columns} dataSource={filteredLogs} pagination={false} scroll={{ x: 600, y: 500 }} />

        <div style={{ textAlign: 'center', marginTop: 16 }}>
          {loading ? (
            <Spin />
          ) : (
            <Button type="primary" onClick={() => setPage((prev) => prev + 1)}>
              Load More
            </Button>
          )}
        </div>
      </div>
    </Layout>
  )
}

export default GlobalSearchLogs
